import ContactButton from "../components/ContactButton";
import SideList from "../components/sections/SideList";
import Title from "../components/sections/Title";

const contacts = [
    <>
        <i className="bi bi-telephone-fill contact-icon" />
        <ContactButton className="phone" onClick={onPhone}>562</ContactButton>
    </>,
    <>
        <i className="bi bi-envelope-fill contact-icon" />
        <ContactButton className="email" onClick={onMail}>@</ContactButton>
    </>,
    <>
        <i className="bi bi-house-fill contact-icon" />
        <ContactButton className="address" onClick={onAddress}>Fő utca</ContactButton>
    </>
];
const socialMedia = [
    <>
        <i className="bi bi-instagram contact-icon" />
        <a
            className="social-media"
            href="https://www.instagram.com/egeszsegenergiaegyensuly/"
        >
            @egeszsegenergiaegyensuly
        </a>
    </>,
    <>
        <i className="bi bi-facebook contact-icon" />
        <a
            className="social-media"
            href="https://www.facebook.com/profile.php?id=100086488571841"
        >
            /egeszseg-energia-egyensuly
        </a>
    </>,
    <>
        <i className="bi bi-people-fill contact-icon" />
        <a
            className="social-media"
            href="https://www.facebook.com/groups/1195232611808323"
        >
            Gyógyszer vagy alternatív kezelés?
        </a>
    </>
];

function onPhone(){
    const tel = atob('KzM2LTMwLTU2Mi03MzMw');
    window.location.href = `tel:${tel}`;
}

function onMail(){
    const mail = atob('ZWdlc3pzZWcuZW5lcmdpYS5lZ3llbnN1bHlAZ21haWwuY29t');
    window.location.href = `mailTo:${mail}`;
}

function onAddress(){
    const address = atob('Njc1OCUyMFIlQzMlQjZzemtlJTJDJTIwRiVDNSU5MSUyMHV0Y2ElMjAxMDku');
    window.location.href = `http://maps.google.com/?q=:${address}`;
}

function About(){
    return (
        <main className="flex-grow-1">
            <Title title="Elérhetőségek" />
            <SideList title="Kojnok Tünde" listItems={contacts} id="contacts"/>
            <SideList title="Közösségi média" listItems={socialMedia} id="social-media" alignRight={true} />
        </main>
    );
}

export default About;